import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import { twMerge } from 'tailwind-merge'

import { Button } from './styles'

export default function ({
    children, 
    loading = false,
    loadingText = 'Aguarde...', 
    disabled = false, 
    type = 'button', 
    fab = false, 
    tiny = false, 
    tooltip, 
    tooltipPosition = 'right', 
    className = '', 
    afterContent = null,
    ...props 
}) {
    return (
        <>
            <Button 
                type={type} 
                disabled={disabled} 
                loading={loading ? 1 : undefined}
                fab={fab}
                tiny={tiny}
                data-tip={tooltip}
                data-for="button-tooltip"
                className={twMerge(`${fab ? 'fab' : ''}`, 'bg-emerald-600 text-white', className)}
                {...props}
            >
                {loading ? (
                    <>{loadingText}</>
                ) : (
                    <>{children}</>
                )}
            </Button>

            {afterContent && (
                <div className="w-full flex justify-center">
                    {afterContent}
                </div>
            )}

            {tooltip && (
                <ReactTooltip
                    id="button-tooltip"
                    place={tooltipPosition}
                    effect="solid"
                    type="dark"
                    html
                />
            )}
        </>
    )
}
